import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { addDataLayer } from 'lib/GoogleTagManager';

export default () => {
  const { pathname, search } = useLocation();
  const accountId = useSelector((state) => state.accountId);

  useEffect(() => {
    const dataLayer = {
      event: 'vpload',
      vPath: `/easycare${pathname}`,
      journey: 'Contact Lens Subscriptions',
      'page.contentID': `/easycare${pathname}`,
      userId: accountId,
    };
    addDataLayer(dataLayer);
  }, [pathname, search, accountId]);

  return null;
};
